module.exports = __webpack_public_path__ + "img/Folded_Paper_samen_sterker.9340e3a7.svg";